module.exports = __webpack_public_path__ + "img/3Dian5_2.ea04393f.png";